import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import TeamMemberAccordion from './teamMembers/MemberAccordion';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTeamMembers, updateTeamMembersOrder } from '../../../store/startup/team/teamSlice';
import { useParams } from 'react-router-dom';

const CampaignTeam = () => {
  const dispatch = useDispatch();
  const { startupId } = useParams();
  const { teamMembers, loading, error } = useSelector(state => ({
    teamMembers: state.team?.teamMembers || [],
    loading: state.team?.loading || false,
    error: state.team?.error || null
  }));
  const [newMembers, setNewMembers] = useState([]);

  useEffect(() => {
    if (startupId) {
      dispatch(fetchTeamMembers(startupId));
    }
  }, [dispatch, startupId]);

  const handleAddNew = () => {
    const emptyMember = {
      isNew: true,
      startupId: startupId,
      firstName: '',
      lastName: '',
      positionTitle: '',
      biography: '',
      responsibilities: '',
      expertise: '',
      relationToStartup: '',
      email: '',
      instagram: '',
      profilePhotoPath: '',
      resumeFilePath: '',
      order: teamMembers.length + newMembers.length + 1 // Order 1'den başlıyor
    };
    setNewMembers([...newMembers, emptyMember]);
  };

  const handleNewMemberSaved = () => {
    setNewMembers([]);
  };

  const handleMoveUp = async (index) => {
    if (index === 0) return;
    
    const updatedMembers = teamMembers.map(member => ({
      ...member
    }));
    
    const currentMember = { ...updatedMembers[index] };
    const previousMember = { ...updatedMembers[index - 1] };

    currentMember.order -= 1;
    previousMember.order += 1;

    updatedMembers[index] = previousMember;
    updatedMembers[index - 1] = currentMember;

    try {
      await dispatch(updateTeamMembersOrder(updatedMembers)).unwrap();
      await dispatch(fetchTeamMembers(startupId));
    } catch (error) {
      console.error('Error updating order:', error);
    }
  };

  const handleMoveDown = async (index) => {
    if (index === teamMembers.length - 1) return;
    
    const updatedMembers = teamMembers.map(member => ({
      ...member
    }));
    
    const currentMember = { ...updatedMembers[index] };
    const nextMember = { ...updatedMembers[index + 1] };

    currentMember.order += 1;
    nextMember.order -= 1;

    updatedMembers[index] = nextMember;
    updatedMembers[index + 1] = currentMember;

    try {
      await dispatch(updateTeamMembersOrder(updatedMembers)).unwrap();
      await dispatch(fetchTeamMembers(startupId));
    } catch (error) {
      console.error('Error updating order:', error);
    }
  };

  if (loading) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography>Yükleniyor...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">Hata: {error}</Typography>
      </Box>
    );
  }

  return (
    <Box marginTop={1}>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Box sx={{ flexGrow: 1, width: '80%' }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Takım Üyeleri
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'right', width: '20%', height: '1%' }}>
          <Button variant="outlined" size="small" color="primary" startIcon={<Add />} onClick={handleAddNew}>
            Yeni Ekle
          </Button>
        </Box>
      </Box>
      {Array.isArray(teamMembers) && teamMembers.map((member, index) => (
        <TeamMemberAccordion 
          key={member.teamMemberId} 
          member={member} 
          onMoveUp={() => handleMoveUp(index)} 
          onMoveDown={() => handleMoveDown(index)} 
          disableMoveUp={index === 0} 
          disableMoveDown={index === teamMembers.length - 1} 
        />
      ))}
      {newMembers.map((member, index) => (
        <TeamMemberAccordion 
          key={`new-${index}`} 
          member={member}
          onSaved={handleNewMemberSaved}
        />
      ))}
    </Box>
  );
};

export default CampaignTeam;
